// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KFHC","name":"styles_name__3wyHb","phone":"styles_phone__3LuWa"};